// Wallpaper pattern-colour seeding guard (pure — no React, no I/O).
//
// Shared/Wallpaper is rendered by TWO callers with DIFFERENT prop contracts:
//   * SegmentSettings (per-Segment)  — passes `handlePatternColorInitialChange`
//   * Main/WallpaperTab (wheel-level) — does NOT pass it (optional prop)
//
// The seeding effect fired whenever `patternColor === undefined` and then called
// that callback unconditionally. On any wheel whose API `wallpaper_settings` is
// null, the wheel-level slice hydrated to `{}` (see redux/reducers/wheelWallpaper
// — fixed at the source), so `patternColor` WAS undefined and the effect threw
// "handlePatternColorInitialChange is not a function", unmounting the whole
// Design > Wallpaper pane. Wheels that carry full wallpaper_settings never hit it,
// which is exactly why the crash looked wheel-specific.
//
// Extracted as a pure predicate so the previously-failing decision is unit-testable
// without mounting the 800-line picker and its MUI/procedural-library import graph.

/**
 * Should the picker seed an initial pattern colour?
 *
 * Only when the colour is genuinely unset AND a seeding callback was actually
 * supplied by the caller. `null` is a deliberate "cleared" value, not "unset",
 * so it does not trigger seeding.
 *
 * @param {unknown} patternColor current pattern colour from the caller's state
 * @param {unknown} handlePatternColorInitialChange optional seeding callback
 * @returns {boolean}
 */
export const shouldSeedPatternColor = (
  patternColor,
  handlePatternColorInitialChange,
) =>
  patternColor === undefined &&
  typeof handlePatternColorInitialChange === "function";
